import component from './pay-by-card.component';
import routes from './pay-by-card.routes';

export default angular
  .module('fizyweb.paycell.paybycard', [])
  .component('fizyPaycellPayByCard', component)
  .config(routes).name;



// WEBPACK FOOTER //
// src/app/buy/pay-by-card/pay-by-card.module.ts